
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import PhoneCallModal from './components/feature/PhoneCallModal';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <PhoneCallModal />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
